import axios from 'axios'

const api = axios.create({
  baseURL: 'https://uay.herokuapp.com',
  // baseURL: 'http://localhost:3070',
})
export default api;
